import React, {useEffect, useState} from "react"

import {useApiHostContext} from "~/api";
import {Card} from "~/components/Card/Card"
import {Raw} from "~/components/raw"

import {Heading} from "~/components/Heading/Heading";
import {Link} from "~/components/Link/Link";
import {useTranslation} from "react-i18next";

import {List, AkkreditElements} from "./components/List/List"

import styles from "./index.module.css"
import fetch from "isomorphic-unfetch";

interface AkkreditSection {
  NAME: string;
  DESCRIPTION: string;
  UF_AKKREDIT_BLOCK_LINK: string;
  UF_AKKREDIT_BLOCK_TYPE: string;
  ELEMENT: AkkreditElements[]
}

export const Akkredit: React.FC = () => {
  const [blocks, setBlocks] = useState([] as AkkreditSection[])
  const apiHost = useApiHostContext()

  const { t } = useTranslation()

  useEffect(() => {
    const genRandomKey = async () => {
      const obj = await fetch(apiHost + '/akkredit/blocks');
      const result = await obj.json()

      setBlocks(result.BLOCKS)
    };

    genRandomKey();
  }, [])

  return (
    <>
      {blocks.map((item, index) => {
        if (item.UF_AKKREDIT_BLOCK_TYPE == 'Ссылки') {
          return (
            <Card className={styles.Card} key={index}>
              <Heading className={styles.Title} like="h2">
                <Raw html={item.NAME} />
              </Heading>
              <List element={item.ELEMENT}/>
            </Card>
          )
        } else {
          return (
            <Card className={styles.Card} key={index}>
              <Heading className={styles.Title} like="h2">
                <Raw html={item.NAME} />
              </Heading>
              <div className={styles.Text}>
                <Raw html={item.DESCRIPTION} />
              </div>
              {item.UF_AKKREDIT_BLOCK_LINK && (
                <Link href={item.UF_AKKREDIT_BLOCK_LINK} view="arrow">
                  <Raw html={t("procurements.Cards.02.Link")}/>
                </Link>
              )}
            </Card>
          )
        }
      })}
    </>
  )
}